@if (tabItems$ | async; as tabItems) {
  <div class="bp-tabs">
    <!-- Custom header (we hide the Material one) -->
    @if (withPills) {
      <div class="bp-tabs-header">
        <bp-pill-group>
          @for (item of tabItems; track item; let i = $index) {
            @if (item.labelComponent || item.label) {
              <bp-pill
                [isActive]="i === selectedIndex"
                (click)="selectedIndex = i">
                @if (item.labelComponent) {
                  <ng-container *ngTemplateOutlet="item.labelComponent.labelContent"> </ng-container>
                }
                @if (!item.labelComponent) {
                  {{ item.label }}
                }
              </bp-pill>
            }
          }
        </bp-pill-group>
      </div>
    }
    <div class="bp-tabs-body" [class.hidden-mat-header]="withPills">
      <mat-tab-group
        [(selectedIndex)]="selectedIndex"
        [animationDuration]="'0'"
        disableRipple="true"
        mat-stretch-tabs="false"
        mat-align-tabs="start">
        <!-- mat-tab-label is rendered only if we opt-out of using pills as header -->
        @for (item of tabItems; track item) {
          <mat-tab [label]="item.label">
            <ng-container *ngTemplateOutlet="item.itemContent"></ng-container>
          </mat-tab>
        }
      </mat-tab-group>
    </div>
  </div>
}
